import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import * as dotenv from 'dotenv';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { MsalProvider, MsalContext } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./services/authConfig";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
dotenv.config();

const pca = new PublicClientApplication(msalConfig);

ReactDOM.render(
	<MsalProvider instance={pca}>
		<BrowserRouter basename={baseUrl}>
			<App />
		</BrowserRouter>
	</MsalProvider>,
	rootElement);

//ReactDOM.render(
//	<BrowserRouter basename={baseUrl}>
//		<App />
//	</BrowserRouter>,
//	rootElement);

registerServiceWorker();

